import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BaseDataTableFilter } from '../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { DataTableFilterMessageService } from '../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { ReservationFilterStateService } from '../../../services/reservation-filter-state.service';
import { ReservationMessageService } from '../../../services/reservation-message.service';

@Component({
  selector: 'app-reservation-filter-from-date',
  templateUrl: './reservation-filter-from-date.component.html',
  styleUrls: ['./reservation-filter-from-date.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatInputModule
  ]
})
export class ReservationFilterFromDateComponent extends BaseDataTableFilter implements OnInit {

  @ViewChild('picker') datePicker!: MatDatepicker<Date>;

  constructor(
    private filterMessageService: DataTableFilterMessageService,
    private reservationFilterStateService: ReservationFilterStateService,
    private reservationMessageService: ReservationMessageService
  ) { 
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.reservationFilterStateService.arrivalDate !== '') {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  datePickerOpened() {
    this.filterMessageService.setClickoutEnabled(false);
  }

  datePickerClosed() {
    this.filterMessageService.setClickoutEnabled(true);
  }

  onApplyClicked(): void {
    this.reservationMessageService.applyFilter();
    if (this.reservationFilterStateService.arrivalDate === '') {
      this.filterMessageService.setActive({ filterId: this.id, active: false });
    } else {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onClearClicked(): void {
    this.reservationFilterStateService.resetArrivalDateFilter();
    this.reservationMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getFilterStateService(): ReservationFilterStateService {
    return this.reservationFilterStateService;
  }

  private getFilterStatusText(): string {
    return formatDate(this.reservationFilterStateService.arrivalDate, 'MMM d, y', 'en-US', 'UTC');
  }
}